import { mapState, mapGetters, mapActions } from 'vuex'

// #region Auth
export const authComputed = {
  ...mapState('auth', {
    authDetails: state => state.authDetails,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const authMethods = mapActions('auth', ['logIn', 'logOut'])

// #endregion

export const memberMethods = mapActions('member', [
  'getAllMembers',
  'createMembers',
  'getAllUnpaidMembers',
  'getMemberByBarcode',
])

export const paymentMethods = mapActions('payment', [
  'doPayment',
  'getPaymentForcurrentDate',
  'sendEmailToClient',
])

export const attendanceMethods = mapActions('attendance', [
  'markAttendance',
  'checkForAttendance',
])
